import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

import Home from "@/pages/Home";
import MenuPage from "@/pages/Menu";
import Gallery from "@/pages/Gallery";
import Events from "@/pages/Events";
import Reserve from "@/pages/Reserve";
import Contact from "@/pages/Contact";
import Privatisation from "@/pages/Privatisation";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Admin from "@/pages/Admin";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { GlobalSchema } from "@/components/SEO";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Layout({ children }) {
  return (
    <div className="App">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <GlobalSchema />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/menu" element={<Layout><MenuPage /></Layout>} />
          <Route path="/galerie" element={<Layout><Gallery /></Layout>} />
          <Route path="/evenements" element={<Layout><Events /></Layout>} />
          <Route path="/reserver" element={<Layout><Reserve /></Layout>} />
          <Route path="/privatisation" element={<Layout><Privatisation /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/mentions-legales" element={<Layout><MentionsLegales /></Layout>} />
          <Route path="/confidentialite" element={<Layout><Confidentialite /></Layout>} />
          <Route path="/admin" element={<Layout><Admin /></Layout>} />
          <Route path="*" element={<Layout><Home /></Layout>} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
